export { MyAssetsTemplate } from './MyAssetsTemplate';
export * from './MyAssetsTemplate.types';
